/**
 * ISO 2-letter country codes for regions where Xbox development is not
 * supported. Users who select one of these on the /new sign-up form are
 * blocked from onboarding: the UI hides the remaining fields and shows an
 * unsupported-region message, and the backend rejects the submission.
 */
export const blockedCountryCodes = new Set<string>([
  "AF", // Afghanistan
  "CU", // Cuba
  "KP", // North Korea
  "IR", // Iran
  "RU", // Russia
  "SY", // Syria
]);

/** Returns true when the given ISO 2-letter country code is a blocked region. */
export const isBlockedCountryIso = (isoCode: string | undefined): boolean =>
  !!isoCode && blockedCountryCodes.has(isoCode);
